const layerStyles = {
  card: {
    bg: "card",
    border: "1px solid",
    borderColor: "border",
    borderRadius: "xl",
    boxShadow: "sm",
  },
  glassHover: {
    transition: "all 0.3s ease",
    _hover: {
      bg: "rgba(255,255,255,0.6)",
      backdropFilter: "blur(12px)",
      borderColor: "rgba(255,255,255,0.3)",
      boxShadow: "0 8px 32px rgba(255,255,255,0.1)",
      transform: "translateY(-2px)",
    },
  },
  glassButton: {
    bg: "rgba(255,255,255,0.1)",
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(255,255,255,0.2)",
    transition: "all 0.3s ease",
    _hover: {
      bg: "rgba(255,255,255,0.2)",
      borderColor: "rgba(255,255,255,0.3)",
      boxShadow: "0 8px 32px rgba(255,255,255,0.15)",
      transform: "translateY(-2px)",
    },
  },
};
export default layerStyles;
